import { Box } from "@mui/material";

import { ScrollArea } from "../../../../../components/ScrollBar";
import CustomTitle from "../../../../../components/app/CustomTitle";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import CopyButton from "../../../../../utils/util-components/CopyButton";
import CircleIcon from "@mui/icons-material/Circle";
import { DEFAULT_LABEL_COLOR } from "../../../../../utils/utils";
import { sections } from "./template-constant";

const DynamicVariablesTooltip = () => {
  return (
    <ScrollArea height={"calc(100vh - 500px)"} noWrap enableHorizontalScroll>
      <Box
        style={{
          padding: "20px",
          backgroundColor: "background.paper",
          color: "black",
        }}
      >
        {" "}
        <Text fontSize="12px" color={DEFAULT_LABEL_COLOR} mb={1}>
          You can use below variables in your email template :
        </Text>
        {sections.map((section) => (
          <Box
            key={section.title}
            style={{
              marginBottom: "40px",
            }}
          >
            <CustomTitle>{section.title}</CustomTitle>

            {section.groups.map((grp, index) => (
              <Box key={index}>
                {grp.label && <CustomTitle>{grp.label}</CustomTitle>}
                <Flex flexDirection={"column"}>
                  {grp.fields.map((field) => (
                    <Flex
                      key={field.value}
                      style={{
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        width: "fit-content",
                        gap: "10px",
                      }}
                    >
                      <CircleIcon
                        fontSize="small"
                        sx={{ color: "black", fontSize: "5px" }}
                      />
                      <Text> {field.label} :</Text>
                      <Text>{field.value}</Text>
                      <CopyButton
                        onClick={() => {
                          navigator.clipboard.writeText(field.value);
                        }}
                      />
                    </Flex>
                  ))}
                </Flex>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </ScrollArea>
  );
};
export default DynamicVariablesTooltip;
